import { Col, Row } from "reactstrap";
import { GetLanguageString } from "../../../helper/Components";
import { GetSelectedLanguage } from "../../../helper/Method";

const formatAmount = (value) =>
  new Intl.NumberFormat().format(Number(value) || 0);

const chipStyle = (background, color) => ({
  background,
  color,
  borderRadius: "999px",
  padding: "6px 12px",
  fontWeight: 600,
  fontSize: "13px",
  display: "inline-block",
  marginRight: 8,
  marginBottom: 8,
});

const CashBalanceReportSummary = ({ totalUnits, exceedingCount, limits }) => {
  const urClass = GetSelectedLanguage() === "ur" ? "ur" : "";
  return (
    <Row className="m-b-md">
      <Col md="12">
        <span className={urClass} style={chipStyle("rgba(72, 106, 132, 0.12)", "#2D4455")}>
          <GetLanguageString props="cash_balance_report_total_units" />: {totalUnits ?? 0}
        </span>
        <span className={urClass} style={chipStyle("rgba(220, 53, 69, 0.12)", "#8a1f2b")}>
          <GetLanguageString props="cash_balance_report_exceeding_count" />: {exceedingCount ?? 0}
        </span>
        <span className={urClass} style={chipStyle("rgba(26, 179, 148, 0.12)", "#1B6258")}>
          <GetLanguageString props="cash_balance_report_halqa_limit" />: {formatAmount(limits?.halqaCashLimit)}
        </span>
        <span className={urClass} style={chipStyle("rgba(26, 179, 148, 0.12)", "#1B6258")}>
          <GetLanguageString props="cash_balance_report_tanzeem_limit" />: {formatAmount(limits?.muqamiTanzeemCashLimit)}
        </span>
        <span className={urClass} style={chipStyle("rgba(255, 193, 7, 0.18)", "#8a6d1b")}>
          <GetLanguageString props="cash_balance_report_usra_limit" />: {formatAmount(limits?.usraCashLimit)}
        </span>
        <span className={urClass} style={chipStyle("rgba(255, 193, 7, 0.18)", "#8a6d1b")}>
          <GetLanguageString props="cash_balance_report_usra_days" />: {limits?.usraCashHoldingDays ?? 0}
        </span>
      </Col>
    </Row>
  );
};

export default CashBalanceReportSummary;
